export default __webpack_public_path__ + "static/media/splash_numbers_landscape.fe0a7432.png";